"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrap = wrap;
function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}


//////////////////
// WEBPACK FOOTER
// ./~/google-map-react/lib/utils/lib_geo/wrap.js
// module id = 174
// module chunks = 0